const angular = require('angular')
const sharedMailboxCtrl = require('./sharedMailboxCtrl')
const sharedMailboxService = require('./sharedMailboxService')

module.exports = angular
  .module('hxphone.sharedMailbox', [])
  .factory('sharedMailboxService', sharedMailboxService)
  .controller('sharedMailboxCtrl', sharedMailboxCtrl)



// WEBPACK FOOTER //
// ./src/js/setting/sharedMailbox/module.js